<template>
    <md-menu md-direction="bottom-end" md-align-trigger md-close-on-click>
        <md-button class="md-just-icon md-primary" md-menu-trigger>
            <md-icon> more_horiz</md-icon>
        </md-button>

        <md-menu-content>
            <li>
                <a @click="actionRestore">Restore</a>
            </li>
        </md-menu-content>
    </md-menu>
</template>

<script>
    export default {
        name: "OrganizationDeletedMoreDropdown",
        props: {
            organization: {
                type: Object,
                required: true,
            }
        },
        methods: {
            actionRestore() {
                this.$api.restoreOrganization({
                    segments: {
                        id: this.organization.id,
                    },
                }).then(() => {
                    this.$bus.emit('updateIndex')
                })
            }
        }
    }
</script>

<style scoped>

</style>